<template>
  <v-btn
    :color="color"
    :variant="variant"
    :height="height"
    :class="btnClass"
    :block="isDisplayBlock"
    @click="emits('click')"
  >
    <slot />
  </v-btn>
</template>

<script lang="ts" setup>
const props = withDefaults(defineProps<{
  /** ボタンの色 */
  color?: 'primary' | 'secondary' | 'danger' | 'secondaryBk';
  /** ボタンの種類 */
  variant?: 'flat' | 'outlined' | 'text';
  /** ボタンのサイズ（高さ） */
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  /** ボタンラベルのアンダーラインを非表示にするかどうか（ボタンの種類が"text"の場合のみ） */
  hideUnderline?: boolean;
}>(), {
  color: 'primary',
  variant: 'flat',
  size: 'md',
  hideUnderline: false,
});

const emits = defineEmits(['click']);

const height = computed(() => {
  switch (props.size) {
    case 'xs':
      return '1.5rem';
    case 'sm':
      return '3rem';
    case 'md':
      return '3.5rem';
    case 'lg':
      return '5rem';
    case 'xl':
      return '6rem';
    default:
      return '3.5rem';
  }
});

const btnClass = computed(() => {
  let cssClass = '';

  // ボタンタイプによって当てるstyleを変える
  if (props.variant === 'flat') {
    cssClass += 'text-white btn-bg';
  }
  else if (props.variant === 'outlined') {
    cssClass += 'btn-bg text-' + props.color;
  }
  else if (props.variant === 'text') {
    cssClass += 'text-' + props.color;
    if (!props.hideUnderline) {
      cssClass += ' text-decoration-underline';
    }
  }

  // ボタンサイズによってフォントサイズを変える
  if (['md', 'lg', 'xl'].includes(props.size)) {
    cssClass += ' btn-font-md';
  }
  else if (props.size === 'xs') {
    cssClass += ' btn-font-xs';
  }
  else {
    cssClass += ' btn-font-sm';
  }

  return cssClass;
});

const isDisplayBlock = computed(() => props.variant !== 'text');
</script>

<style lang="scss" scoped>
.btn-font-md {
  font-size: 1.25rem;
  font-weight: bold;
}

.btn-font-sm {
  font-size: 1rem;
  font-weight: bold;
}

.btn-font-xs {
  font-size: 0.875rem;
  font-weight: bold;
}

.btn-bg {
  background-color: white;
}
</style>
